import jQueryWrapped from 'jquery';
import 'jquery-input-lettering/dist/jquery.inputLettering.js';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/l10n/index';
import 'flatpickr/dist/themes/light.css';
// import 'font-awesome/css/font-awesome.min.css';  // Import Font Awesome's CSS

import './styles.css';
import './utils/jsErrorLogger.js';
import { initApp } from './app.js';
import api from "./utils/api";

// Load Roboto font
const fontLink = document.createElement('link');
fontLink.href = 'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap';
fontLink.rel = 'stylesheet';
document.head.appendChild(fontLink);
// const head = document.head;
// head.insertBefore(fontLink, head.firstChild);

const jQ = jQueryWrapped.noConflict(true);

// jQ.fn.letteringInput = window.jQuery.fn.letteringInput;

// Bind flatpickr to jQuery
jQ.fn.flatpickr = function (config) {
  return this.each(function () {
    flatpickr(this, config);
  });
};

window.jQ = jQ;
window.flatpickr = flatpickr;

jQ(() => {
  jQ('.booking-widget:not([data-initialized])').each((i, el) => {
    const $container = jQ(el);
    $container.attr('data-initialized', 'true');
    const apiObj = api();
    initApp({ $: jQ, rootContainer: $container, api: apiObj });
  });
});
